import moment from "moment";
import {
  LEAD_EXECUTIVE_INDUSTRY_LIST,
  LEAD_EXECUTIVE_GEOLOCATION,
  LEAD_EXECUTIVE_COMPANY_TYPE,
  LEAD_EXECUTIVE_EMPLOYEE_COUNT,
  LEAD_EXECUTIVE_REVENUE_RANGE,
  LEAD_EXECUTIVE_COMPANYLIST,
  LEAD_EXECUTIVE_COMPANY_SEARCH_PAYLOAD,
  LEAD_EXECUTIVE_ADVANCED_SELECTED_FILTERS,
  LEAD_EXECUTIVE_PAGINATION_VALUE,
  LEAD_EXECUTIVE_SELECTED_RECORDS,
  LEAD_EXECUTIVE_SAVE_SEARCH,
  LEAD_EXECUTIVE_DOWNLOAD_COMPANYLIST_ERROR,
  LEAD_EXECUTIVE_SAVE_SEARCH_ERROR,
  LEAD_EXECUTIVE_INDUSTRY_LIST_ERROR,
  LEAD_EXECUTIVE_COMPANY_TYPE_ERROR,
  LEAD_EXECUTIVE_EMPLOYEE_COUNT_ERROR,
  LEAD_EXECUTIVE_REVENUE_RANGE_ERROR,
  LEAD_EXECUTIVE_COMPANYLIST_ERROR,
  LEAD_EXECUTIVE_EMPTY_ERROR_OBJ_LISTING,
  LEAD_EXECUTIVE_SAVE_SEARCH_LIST,
  LEAD_EXECUTIVE_SAVE_SEARCH_LIST_ERROR,
  LEAD_EXECUTIVE_COMPANY_TAG_LIST,
  LEAD_EXECUTIVE_COMPANY_TAG_LIST_ERROR,
  LEAD_EXECUTIVE_GROUP_COMPANY_TAG,
  LEAD_EXECUTIVE_GROUP_COMPANY_TAG_ERROR,
  LEAD_EXECUTIVE_EMPLOYEELIST,
  LEAD_EXECUTIVE_EMPLOYEELIST_ERROR,
  LEAD_STATUS_LIST,
  LEAD_STATUS_LIST_ERROR,
  LEAD_PAGE_LAYOUT,
  LEAD_RATING_LIST,
  LEAD_RATING_LIST_ERROR,
  LEAD_EXECUTIVE_NOTES,
  LEAD_EXECUTIVE_NOTES_ERROR,
  LEAD_EXECUTIVE_REMARKS,
  LEAD_EXECUTIVE_REMARKS_ERROR,
  UNQUALIFIED_REASONS,
} from "../actionType/leadListingType";
import {
  getAuthMethod,
  getMethod,
  patchAuthMethod,
  postAuthMethod,
  putAuthMethod,
} from "../services/HttpServices";
import { errEnum, ErrKey } from "../config";
import {
  getClientRemarksApiUrl,
  industryApiUrl,
  employeeCountApiUrl,
  companyTypeApiUrl,
  revenueRangeApiUrl,
  companyListingApiUrl,
  saveSearch,
  saveSearchListApiUrl,
  getClientLeadsUrl,
  getClientLeadsKanbanUrl,
  getLeadStatusApiUrl,
  getLeadRatingApiUrl,
  getClientNotesApiUrl,
  createBatchClientLeads,
  clientLeadsUrl,
  createLeadTags,
  allTags,
  unqualifiedReasons,
} from "../constant/Constant";
import { dispatchStatus } from "./commonActionCreator";
import { Geolocation } from "../constant/Geolocation";
import {
  createLeadPayload,
  getSubscriptionUserInfo,
  getUserInfo,
} from "../utils/utils";
import { formatLeadsPayload } from "../utils/formatLeadsPayload";

export const getIndustryList = (payload) => (dispatch) => {
  return getAuthMethod(industryApiUrl)
    .then((res) => {
      dispatch({
        type: LEAD_EXECUTIVE_INDUSTRY_LIST,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: LEAD_EXECUTIVE_INDUSTRY_LIST_ERROR,
        payload:
          {
            [errEnum.LEAD_EXECUTIVE_INDUSTRY_LIST_ERROR]:
              err.response.data[ErrKey],
          } || "Error Occured",
      });
    });
};

export const getCompanyTypeList = (payload) => (dispatch) => {
  return getAuthMethod(companyTypeApiUrl)
    .then((res) => {
      dispatch({
        type: LEAD_EXECUTIVE_COMPANY_TYPE,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: LEAD_EXECUTIVE_COMPANY_TYPE_ERROR,
        payload:
          {
            [errEnum.LEAD_EXECUTIVE_COMPANY_TYPE_ERROR]:
              err.response.data[ErrKey],
          } || "Error Occured",
      });
    });
};

export const getEmployeeCountList = (payload) => (dispatch) => {
  return getAuthMethod(employeeCountApiUrl)
    .then((res) => {
      dispatch({
        type: LEAD_EXECUTIVE_EMPLOYEE_COUNT,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: LEAD_EXECUTIVE_EMPLOYEE_COUNT_ERROR,
        payload:
          {
            [errEnum.LEAD_EXECUTIVE_EMPLOYEE_COUNT_ERROR]:
              err.response.data[ErrKey],
          } || "Error Occured",
      });
    });
};

export const getRevenuerangeList = (payload) => (dispatch) => {
  return getAuthMethod(revenueRangeApiUrl)
    .then((res) => {
      dispatch({
        type: LEAD_EXECUTIVE_REVENUE_RANGE,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: LEAD_EXECUTIVE_REVENUE_RANGE_ERROR,
        payload:
          {
            [errEnum.LEAD_EXECUTIVE_REVENUE_RANGE_ERROR]:
              err.response.data[ErrKey],
          } || "Error Occured",
      });
    });
};

export const getCompanyList = (payload, paginationValues) => (dispatch) => {
  dispatch(dispatchStatus(true));
  const url = createLeadPayload(
    payload,
    paginationValues,
    companyListingApiUrl,
  );
  // console.log(url,'urlurlurl')
  return getMethod(url)
    .then((res) => {
      dispatch({
        type: LEAD_EXECUTIVE_COMPANYLIST,
        payload: res.data,
        count: res?.headers["X-Total-Count"],
      });
      dispatch(dispatchStatus(false));
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: LEAD_EXECUTIVE_COMPANYLIST_ERROR,
        payload:
          {
            [errEnum.LEAD_EXECUTIVE_COMPANYLIST_ERROR]:
              err.response.data[ErrKey],
          } || "Error Occured",
      });
    });
};

export const getCompanyListWithStartAndEnd =
  (paginationValues) => (dispatch) => {
    let url = `${companyListingApiUrl}?page=${paginationValues?.start}&size=${paginationValues?.end}`;
    return getMethod(url)
      .then((res) => {
        dispatch({
          type: LEAD_EXECUTIVE_COMPANYLIST,
          payload: res.data,
          count: res?.headers["X-Total-Count"],
        });
      })
      .catch((err) => {
        if (!err?.response?.data) return;
        dispatch({
          type: LEAD_EXECUTIVE_COMPANYLIST_ERROR,
          payload:
            {
              [errEnum.LEAD_EXECUTIVE_COMPANYLIST_ERROR]:
                err.response.data[ErrKey],
            } || "Error Occured",
        });
      });
  };

export const downloadLeadsList = (payload, urlSubstring) => (dispatch) => {
  const url = `${getClientLeadsUrl}/${urlSubstring}?id.in=${payload.join(",")}`;

  return getAuthMethod(url)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (err?.response?.status !== 403) {
        const isLimitExceed = err?.response?.data?.title
          ?.toLowerCase()
          ?.includes("subscriber ussage limit expired");
        const subscription = getSubscriptionUserInfo();
        const currentDate = moment();
        const validToDate = moment(subscription?.validTo);
        const isExpired = validToDate.isBefore(currentDate);
        dispatch({
          type: LEAD_EXECUTIVE_DOWNLOAD_COMPANYLIST_ERROR,
          payload: {
            [errEnum.LEAD_EXECUTIVE_DOWNLOAD_ERROR]: {
              message: subscription?.id
                ? isLimitExceed && !isExpired
                  ? "You have exceeded the download limit for your subscription plan."
                  : "Your subscription has expired. Please renew your subscription to continue using the service."
                : "You do not have an active subscription. Please subscribe to continue using the service.",
            },
          },
        });
      }
      return err;
    });
};

export const getLocation = (payload) => ({
  type: LEAD_EXECUTIVE_GEOLOCATION,
  payload: Geolocation,
});

export const createExecutiveSearchPayload = (payload) => {
  return {
    type: LEAD_EXECUTIVE_COMPANY_SEARCH_PAYLOAD,
    payload: payload,
  };
};

export const saveAdvancedSelectedFilters = (payload) => {
  return {
    type: LEAD_EXECUTIVE_ADVANCED_SELECTED_FILTERS,
    payload: payload,
  };
};

export const savePaginationValues = (payload) => {
  return {
    type: LEAD_EXECUTIVE_PAGINATION_VALUE,
    payload: payload,
  };
};

export const selectedRow = (payload) => {
  return {
    type: LEAD_EXECUTIVE_SELECTED_RECORDS,
    payload: payload,
  };
};

export const saveSearchAction = (payload) => (dispatch) => {
  return postAuthMethod(saveSearch, payload)
    .then((res) => {
      dispatch({
        type: LEAD_EXECUTIVE_SAVE_SEARCH,
        payload: res.data,
      });
      dispatch(saveExecutiveSearchList(payload?.userId));
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: LEAD_EXECUTIVE_SAVE_SEARCH_ERROR,
        payload:
          {
            [errEnum.LEAD_EXECUTIVE_SAVE_SEARCH_ERROR]:
              err.response.data[ErrKey],
          } || "Error Occured",
      });
    });
};

export const emptyErrorObj = () => ({
  type: LEAD_EXECUTIVE_EMPTY_ERROR_OBJ_LISTING,
  payload: {},
});

export const saveExecutiveSearchList = (userId) => (dispatch) => {
  const url = `${saveSearchListApiUrl}?source.equals=Executive&userId.equals=${userId}`;
  return getAuthMethod(url)
    .then((res) => {
      dispatch({
        type: LEAD_EXECUTIVE_SAVE_SEARCH_LIST,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: LEAD_EXECUTIVE_SAVE_SEARCH_LIST_ERROR,
        payload:
          {
            [errEnum.LEAD_EXECUTIVE_SAVE_SEARCH_LIST_ERROR]:
              err.response.data[ErrKey],
          } || "Error Occured",
      });
    });
};

export const getLeadTagList = () => (dispatch) => {
  const url = `${allTags}?type.equals=LEAD`;
  return getAuthMethod(url)
    .then((res) => {
      dispatch({
        type: LEAD_EXECUTIVE_COMPANY_TAG_LIST,
        payload: res.data?.tagsDTOs,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: LEAD_EXECUTIVE_COMPANY_TAG_LIST_ERROR,
        payload:
          {
            [errEnum.LEAD_EXECUTIVE_COMPANY_TAG_LIST_ERROR]:
              err.response.data[ErrKey],
          } || "Error Occured",
      });
    });
};

export const createGroupLeadTag = (payload) => (dispatch) => {
  return postAuthMethod(createLeadTags, payload)
    .then((res) => {
      dispatch(getLeadTagList(payload?.userId));
      return res.data;
    })
    .catch((err) => {
      return err;
    });
};

export const getExecutiveEmployeeList =
  (payload, paginationValues, noLoading) => (dispatch) => {
    window.scrollTo(0, 0);
    if (!noLoading) {
      dispatch(dispatchStatus(true));
    }
    let apiUrl = getClientLeadsUrl;
    if (
      typeof payload?.layout === "string"
        ? parseInt(payload?.layout) === 2
        : payload?.layout === 2
    ) {
      apiUrl = getClientLeadsKanbanUrl;
    }
    const user = getUserInfo();
    const url = formatLeadsPayload(apiUrl, payload, user?.id);
    const isShowUnqualified = !!payload?.selectedLeadStatus?.find(
      (d) => d?.id === 18,
    );
    return getAuthMethod(
      isShowUnqualified
        ? url
        : `${url}${payload?.["Lead Status"] ? "" : "&statusId.notIn=18,17,19"}`,
    )
      .then((res) => {
        dispatch({
          type: LEAD_EXECUTIVE_EMPLOYEELIST,
          payload: res.data,
          count: res?.headers["x-total-count"],
        });
        dispatch(dispatchStatus(false));
      })
      .catch((err) => {
        if (!err?.response?.data) return;
        dispatch({
          type: LEAD_EXECUTIVE_EMPLOYEELIST_ERROR,
          payload:
            {
              [errEnum.LEAD_EXECUTIVE_EMPLOYEELIST_ERROR]:
                err.response.data[ErrKey],
            } || "Error Occured",
        });
      });
  };

export const getLeadStatusList = (payload) => (dispatch) => {
  return getAuthMethod(getLeadStatusApiUrl)
    .then((res) => {
      dispatch({
        type: LEAD_STATUS_LIST,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: LEAD_STATUS_LIST_ERROR,
        payload:
          { [errEnum.LEAD_STATUS_LIST_ERROR]: err.response.data[ErrKey] } ||
          "Error Occured",
      });
    });
};

export const getLeadRatingList = (payload) => (dispatch) => {
  return getAuthMethod(getLeadRatingApiUrl)
    .then((res) => {
      dispatch({
        type: LEAD_RATING_LIST,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: LEAD_RATING_LIST_ERROR,
        payload:
          { [errEnum.LEAD_RATING_LIST_ERROR]: err.response.data[ErrKey] } ||
          "Error Occured",
      });
    });
};

export const setPageLayout = (payload) => {
  return {
    type: LEAD_PAGE_LAYOUT,
    payload: payload,
  };
};

export const getLeadExecutiveNotes =
  (payload = {}) =>
  (dispatch) => {
    const url = `${getClientNotesApiUrl}`;
    //const url =createActivityPayloadForCalendar(payload,apiUrl); getClientRemarksApiUrl
    return getAuthMethod(url)
      .then((res) => {
        dispatch({
          type: LEAD_EXECUTIVE_NOTES,
          payload: res?.data,
        });
      })
      .catch((err) => {
        if (!err?.response?.data) return;
        dispatch({
          type: LEAD_EXECUTIVE_NOTES_ERROR,
          payload:
            {
              [errEnum.LEAD_EXECUTIVE_NOTES_ERROR]: err.response.data[ErrKey],
            } || "Error Occured",
        });
      });
  };

export const getLeadExecutiveRemarks =
  (payload = {}) =>
  (dispatch) => {
    const url = `${getClientRemarksApiUrl}`;
    //const url =createActivityPayloadForCalendar(payload,apiUrl);
    return getAuthMethod(url)
      .then((res) => {
        dispatch({
          type: LEAD_EXECUTIVE_REMARKS,
          payload: res?.data,
        });
      })
      .catch((err) => {
        if (!err?.response?.data) return;
        dispatch({
          type: LEAD_EXECUTIVE_REMARKS_ERROR,
          payload:
            {
              [errEnum.LEAD_EXECUTIVE_REMARKS_ERROR]: err.response.data[ErrKey],
            } || "Error Occured",
        });
      });
  };

export const updateLeadStatus = (payload, callback) => (dispatch) => {
  return putAuthMethod(getClientLeadsUrl, payload.id, payload)
    .then((res) => {
      callback && callback();
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const createLeadsBatch = (payload) => (dispatch) => {
  return postAuthMethod(createBatchClientLeads, payload)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return "error";
    });
};

export const updateLeadDetails = (payload) => (dispatch) => {
  return patchAuthMethod(clientLeadsUrl, payload?.id, payload, {
    headers: {
      "Content-Type": "application/merge-patch+json",
    },
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const searchIndustry = (searchKeyword) => (dispatch) => {
  return getAuthMethod(`${industryApiUrl}?name.contains=${searchKeyword}`)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return err;
    });
};

export const searchLead = (searchKeyword) => (dispatch) => {
  let url = `${getClientLeadsUrl}`;
  if (searchKeyword) {
    url = `${url}?emailId.contains=${searchKeyword}`;
  }
  return getAuthMethod(url)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return err;
    });
};

export const markAsDelete = (payload) => (dispatch) => {
  return patchAuthMethod(getClientLeadsUrl, "bulk-patch", payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const bulkAddToLead = (payload) => (dispatch) => {
  return postAuthMethod(`${getClientLeadsUrl}/bulk-create`, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const transferLeads = (payload) => (dispatch) => {
  return postAuthMethod(`${getClientLeadsUrl}/transfer`, payload)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const getUnqualifiedReasons = (type) => (dispatch) => {
  const url = unqualifiedReasons;
  return getAuthMethod(url)
    .then((res) => {
      dispatch({
        type: UNQUALIFIED_REASONS,
        payload: res?.data?.unqualifiedReasonDTOs,
      });
    })
    .catch((err) => {
      return err;
    });
};
